/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_step_id" */
  WorkInstructionInstanceStepPkey = 'work_instruction_instance_step_pkey'
}

/** select columns of table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepSelectColumn {
  /** column name */
  CompletionProgress = 'completion_progress',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  StepId = 'step_id',
  /** column name */
  StepNumber = 'step_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

/** update columns of table "argo.work_instruction_instance_step" */
export enum ArgoWorkInstructionInstanceStepUpdateColumn {
  /** column name */
  CompletionProgress = 'completion_progress',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  StepId = 'step_id',
  /** column name */
  StepNumber = 'step_number',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionInstanceId = 'work_instruction_instance_id'
}

